import React from 'react'
import ContentLoader from 'react-content-loader'

export default function AccountCardLoader() {
  return (
    <ContentLoader
      speed={2}
      width={300}
      height={600}
      viewBox='0 0 300 600'
      backgroundColor='#ede8e8'
      foregroundColor='#c7c2c2'>
      <rect x='5' y='0' rx='0' ry='0' width='300' height='98' />
      <rect x='5' y='136' rx='0' ry='0' width='300' height='65' />
      <rect x='26' y='217' rx='0' ry='0' width='250' height='42' />
      <rect x='6' y='236' rx='0' ry='0' width='300' height='50' />
      <rect x='26' y='297' rx='0' ry='0' width='250' height='45' />
      <rect x='7' y='317' rx='0' ry='0' width='300' height='51' />
      <rect x='26' y='375' rx='0' ry='0' width='250' height='47' />
      <rect x='6' y='396' rx='0' ry='0' width='309' height='44' />
    </ContentLoader>
  )
}
